const { default: Swiper } = require('swiper');
const { Thumbs, Navigation } = require('swiper/modules');
const { default: tippy } = require('tippy.js');
const { Lightbox } = require('../helpers/Lightbox');
const { pushGtmEvent } = require('../helpers/analytics');

class ApartmentTop {
    constructor() {
        this.root = document.querySelector('[js-apartment-top]');
        if (!this.root) return;

        this.init();
    }

    init() {
        this.priceHistory = this.root.querySelector('[js-price-history]');
        this.priceHistoryButton = this.root.querySelector(
            '[js-price-history-button]'
        );
        this.swiperGallery = this.root.querySelector('.swiper-gallery');
        this.swiperThumbnailsGallery = this.root.querySelector(
            '.swiper-gallery-thumbnails'
        );
        this.prevEl = this.root.querySelector('[swiper-prev]');
        this.nextEl = this.root.querySelector('[swiper-next]');
        this.lightboxTriggers =
            this.root.querySelectorAll('[js-show-lightbox]');

        this.lightboxData = this.root.getAttribute('data-lightbox');
        this.lightboxInstance = new Lightbox(JSON.parse(this.lightboxData));
        this.tippyInstance = null;
        this.galleryInstance = null;
        this.galleryThumbnailsInstance = null;

        this.initTippy();
        this.initGallery();
        this.events();
    }

    initTippy() {
        if (this.priceHistory && this.priceHistoryButton) {
            this.tippyInstance = tippy(this.priceHistoryButton, {
                appendTo: document.body,
                content: this.priceHistory.innerHTML,
                allowHTML: true,
                placement: 'right-start',
                offset: [-10, 8],
                theme: 'price-history',
                trigger: 'click',
                interactive: true,
                maxWidth: '90vw',
                popperOptions: {
                    strategy: 'fixed',
                    modifiers: [
                        {
                            name: 'eventListeners',
                            options: {
                                scroll: false,
                                resize: true,
                            },
                        },
                        {
                            name: 'computeStyles',
                            options: {
                                adaptive: false,
                                gpuAcceleration: true,
                            },
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: 'viewport',
                                padding: 8,
                            },
                        },
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: ['left', 'bottom', 'top'],
                            },
                        },
                    ],
                },
                onShow: () => {
                    if (!this.isDesktop()) return;
                    this.lockScroll();
                },

                onHide: () => {
                    if (!this.isDesktop()) return;
                    this.unlockScroll();
                },
            });
        }
    }

    initGallery() {
        if (this.swiperThumbnailsGallery) {
            this.galleryThumbnailsInstance = new Swiper(
                this.swiperThumbnailsGallery,
                {
                    spaceBetween: 16,
                    breakpoints: {
                        0: {
                            slidesPerView: 5.22,
                        },
                        1024: {
                            slidesPerView: 8,
                        },
                    },
                }
            );
        }

        if (this.swiperGallery) {
            const args = {
                slidesPerView: 1,
                spaceBetween: 16,
                modules: [Navigation],
                navigation: {
                    prevEl: this.prevEl,
                    nextEl: this.nextEl,
                },
            };

            if (this.galleryThumbnailsInstance) {
                args.modules.push(Thumbs);
                args.thumbs = {
                    swiper: this.galleryThumbnailsInstance,
                };
            }

            this.galleryInstance = new Swiper(this.swiperGallery, args);
        }
    }

    events() {
        window.addEventListener('click', this.hideTooltip.bind(this));

        if (this.lightboxTriggers.length) {
            this.lightboxTriggers.forEach(element => {
                element.addEventListener(
                    'click',
                    this.onLightboxTriggerClick.bind(this)
                );
            });
        }

        [
            [this.prevEl, 'prev'],
            [this.nextEl, 'next'],
        ].forEach(([element, direction]) => {
            element?.addEventListener('click', () => {
                requestAnimationFrame(() => {
                    pushGtmEvent('Galeria_mieszkania', {
                        id_mieszkania: this.root.dataset.gtmApartment,
                        nazwa_osiedla: this.root.dataset.gtmEstateName,
                        id_osiedla: this.root.dataset.gtmEstateId,
                        kierunek: direction,
                        nr_zdjecia: (this.galleryInstance?.realIndex || 0) + 1,
                    });
                });
            });
        });
    }

    onLightboxTriggerClick(e) {
        const element = e.target.closest('[js-show-lightbox]');
        if (!element) return;

        const slideToShow = element.getAttribute('js-show-lightbox');

        this.lightboxInstance.openLightbox(slideToShow);
    }

    hideTooltip(e) {
        if (!e.target.closest('[js-close-history-tooltip]')) return;

        if (this.tippyInstance) {
            this.tippyInstance.hide();
        }
    }

    isDesktop() {
        return window.matchMedia('(min-width: 1024px)').matches;
    }

    lockScroll() {
        const scrollbarWidth =
            window.innerWidth - document.documentElement.clientWidth;

        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    unlockScroll() {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
    }
}

new ApartmentTop();
